<app-userapi-shared-oauth [userApi]="userApi" [configured]="userApi.url !== undefined">
  <p translate="INCLUDE_MODALUSERAPI_LABEL_EXACTONLINE" [translateParams]="{ api: userApi.api.name }"></p>

  <div class="flex space-x-2 mb-12">
    @if (userApi.api.urlPrefix) {
      <div class="my-auto text-green-500">{{ userApi.api.urlPrefix }}</div>
    }

    <div class="w-full">
      <app-dropdown
          [hasSelectedItem]="!!userApi.url"
          [items]="[{ value: 'nl' }, { value: 'be' }]"
          [selectedItemDisplayName]="userApi.url"
          (itemSelected)="userApi.url = $event.value; userApi.valid = true"></app-dropdown>
    </div>

    @if (userApi.api.urlPostfix) {
      <div class="my-auto">{{ userApi.api.urlPostfix }}</div>
    }
  </div>
</app-userapi-shared-oauth>
